define.alias("shared/components/shared/color-picker/swatches", "calendar/components/shared/color-picker/swatches");